/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

// Fetch Media Types (for dropdown)
const getMediaTypeList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_types?sort=id&order=desc`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};



// Fetches media product definitions
const getMediaProductDefinitions = async (
    page: number,
    size: number,
    sort: any,
    order: any,
    keyword?: string,
    mediaType?: string,
    status?: string,
    id?: string
  ) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/media/list_media_product_definitions?page=${page}&size=${size}&sort=${sort}&order=${order}${
          keyword ? `&keyword=${keyword}` : ''
        }${
          mediaType ? `&media_name=${mediaType}` : ''
        }${
          status ? `&status=${status}` : ""
        }${
          id ? `&id=${id}` : ''
        }`,
        {
          headers: {
            "x-auth-token": authToken,
            "x-userid": authUserID,
          },
        }
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data;
      }
    }
  };



// Fetches media master list for media name dropdown in product definition form
const getMediaMasterList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_masters?page=1&size=50&sort=id&order=desc&status=active&source_type=INH`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


// Fetch suppliers based on media
const getSuppliersByMedia = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/get_suppliers_by_media`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//create media product definition
const createMediaProductDefinition = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/media/create_media_product_definition`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

// Fetches powder product details (Details screen)
const getMediaProductById = async (productId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/media/list_media_product_definitions?page=1&size=1&sort=id&order=desc&id=${productId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


//change media product status
const changeMediaPowderStatus = async (payload: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/media/update_media_product_definition`,
      payload,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};



export const MediaPowderProductMasterService = {
  getMediaTypeList,
  getMediaProductDefinitions,
  getMediaMasterList,
  getSuppliersByMedia,
  changeMediaPowderStatus,
  createMediaProductDefinition,
  getMediaProductById,
};